(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6644],{

/***/ 86644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68137);
/* harmony import */ var _PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8405);








// import { SITE_BASE_URL } from 'config/env';
var MobilePromotionBanner = function() {
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().pathname;
    var deviceInfo = (0,common_utils__WEBPACK_IMPORTED_MODULE_2__/* .useDevice */ .Fy)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), show = ref[0], setShow = ref[1];
    var isCampaignPage = pathname.startsWith("/cmp/");
    var isWebFunctionPage = pathname.startsWith("/p/");
    var isLpPage = pathname.startsWith("/lp/");
    var isCoursesPage = pathname.startsWith("/courses");
    var isShowingAnimeCharacter = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.isShowingAnimeCharacter;
    });
    // hide banner when user click on anime icon
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isShowingAnimeCharacter) setShow(false);
    }, [
        isShowingAnimeCharacter
    ]);
    if (isCampaignPage || isWebFunctionPage || isLpPage || isCoursesPage) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (!show || deviceInfo.isDesktop) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().banner),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().close),
                onClick: function() {
                    return setShow(false);
                },
                children: "x"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().image),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: "/images/app-icon-1.png",
                            width: 60,
                            height: 60,
                            alt: "logo"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().desc),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                                children: "PostPrime"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().company),
                                children: "アプリで使おう！"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().jump),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                            href: common_utils__WEBPACK_IMPORTED_MODULE_2__/* .ONE_LINK_URL */ .T0,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: (_PromotionBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().link),
                                children: "開く"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MobilePromotionBanner);


/***/ }),

/***/ 68137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"PromotionBanner_banner__MDGs1","content":"PromotionBanner_content__2C9nC","link":"PromotionBanner_link__cWqIR","desc":"PromotionBanner_desc__MHhMb","title":"PromotionBanner_title__NC0e_","company":"PromotionBanner_company__PE2_C","image":"PromotionBanner_image__WFT7p","close":"PromotionBanner_close__4Cgwf","jump":"PromotionBanner_jump__LPWBy"};

/***/ })

}]);